import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./Analytics')));
const ChartDashboard = Loadable(lazy(() => import('./NewDashboard/ChartDashboard')));
const InwardsLoadable = Loadable(lazy(() => import('./NewDashboard/Components/inwards/Inwards')));
const OutwardsLoadable = Loadable(lazy(() => import('./NewDashboard/Components/outwards/Outwards')));
const InventoriesLoadable = Loadable(lazy(() => import('./NewDashboard/Components/inventories/Inventories')));
const CreateInwardsLoadable = Loadable(lazy(() => import('./NewDashboard/Components/inwards/CreateInwards')));
const CreateOutwardsLoadable = Loadable(lazy(() => import('./NewDashboard/Components/outwards/CreateOutwards')));
const RtoLoadable = Loadable(lazy(() => import('./NewDashboard/Components/rto/Rto')));
const CreateRtoLoadable = Loadable(lazy(() => import('./NewDashboard/Components/rto/CreateRto')));
const OutwardApprovalListLoadable = Loadable(lazy(() => import('./NewDashboard/Components/outward-approval/OutwardApprovalList')));
const OutwardApprovalReportLoadable = Loadable(lazy(() => import('./NewDashboard/Components/reports/metabase-reports/OutwardApproval')));

const dashboardRoutes = [
  // { path: '/dashboard/default', element: <Analytics />, auth: authRoles.admin },
  { path: '/dashboard/default', element: <ChartDashboard />, auth: authRoles.admin },
  { path: '/dashboard/inwardstable', element: <InwardsLoadable />, auth: authRoles.admin },
  { path: '/dashboard/outwardstable', element: <OutwardsLoadable />, auth: authRoles.admin },
  { path: '/dashboard/inventories', element: <InventoriesLoadable />, auth: authRoles.admin },
  { path: '/dashboard/createinwards', element: <CreateInwardsLoadable />, auth: authRoles.admin },
  { path: '/dashboard/createoutwards', element: <CreateOutwardsLoadable />, auth: authRoles.admin },
  { path: '/dashboard/rto', element: <RtoLoadable />, auth: authRoles.admin },
  { path: '/dashboard/createRto', element: <CreateRtoLoadable />, auth: authRoles.admin },
  { path: '/dashboard/outward-approval', element: <OutwardApprovalListLoadable />, auth: authRoles.admin },
  { path: '/dashboard/reports', element: <OutwardApprovalReportLoadable />, auth: authRoles.admin },
];

export default dashboardRoutes;
